import React from "react";

/** External libraries */
import { Button } from "@npm-telluria-tecnologia/telluria-ui";

/** Molecules */
import ModalFormDialog from "@molecules/ModalFormDialog";

/** Languages */
import useTranslation from "@languages/useTranslation";
import { ExpiredSessionMessages } from "@languages/interfaces";

/** Styled components */
import * as Styled from "./styles";

/** Component */
const ExpiredSession: React.FC = () => {
  const { t } = useTranslation();

  // Need to be implemented here because this component is inject out of root component (in extra), so don't have
  // access to useAuth
  const handleSignOut = () => {
    localStorage.removeItem("@Topcon:token");
    localStorage.removeItem("@Topcon:lastDataShareAccept");
    localStorage.removeItem("@Topcon:google");
    localStorage.removeItem("@Topcon:themeColors");

    window.location.href = "/customer/login";
  };

  return (
    <Styled.Container>
      <ModalFormDialog title={t(ExpiredSessionMessages.formDialogTitle)} open>
        <Styled.Content>
          <div className="text">
            {t(ExpiredSessionMessages.formDialogContent)}
          </div>
          <Button
            text={t(ExpiredSessionMessages.formDialogActionText)}
            className="default-submit-button"
            onClick={handleSignOut}
          />
        </Styled.Content>
      </ModalFormDialog>
    </Styled.Container>
  );
};

export default ExpiredSession;
